export type MinMaxTimeConfig = {
  min?: number,
  max?: number,
  unit: "months" | "years" | "days",
}

export function isMinMaxTimeConfig(config: unknown): config is MinMaxTimeConfig {
  return typeof config === 'object' && config !== null && config !== undefined && 'unit' in config
    && (config.unit === 'months' || config.unit === 'years' || config.unit === 'days')
    && (!('min' in config) || typeof config.min === 'number')
    && (!('max' in config) || typeof config.max === 'number')
}